class Logger {
  debugModeEnabled;

  constructor(debugModeEnabled) {
    this.debugModeEnabled = !!debugModeEnabled;
  }

  debug(...args) {
    if (!this.debugModeEnabled) {
      return;
    }

    console.debug(...args);
  }

  log(...args) {
    if (!this.debugModeEnabled) {
      return;
    }

    console.log(...args);
  }

  info(...args) {
    console.info(...args);
  }

  warn(...args) {
    console.warn(...args);
  }

  error(...args) {
    console.error(...args);
  }
}

export default Logger;
